var _this = this;
import * as tslib_1 from "tslib";
import loadBrandsSubscriptions from './loadBrandsSubscriptions';
import datapoints from '../datapoints';
import unsubscribeFromBrandSubscriptionService from '../services/unsubscribeFromBrandSubscriptionService';
import useSilentUri from '../utils/useSilentUri';
import { action, orchestrator } from 'satcheljs';
var unsubscribeFromBrandSubscription = action('unsubscribeFromBrandSubscription', function (smtpIdentifier, unsubscribeSilentUris, unsubscribeHttpUri) { return ({
    smtpIdentifier: smtpIdentifier,
    unsubscribeSilentUris: unsubscribeSilentUris,
    unsubscribeHttpUri: unsubscribeHttpUri,
    datapointConfig: {
        name: datapoints.UnsubscribeFromBrandSubscription.datapoint.name,
    },
}); });
export default unsubscribeFromBrandSubscription;
orchestrator(unsubscribeFromBrandSubscription, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!useSilentUri(actionMessage.unsubscribeSilentUris.length)) return [3 /*break*/, 2];
                return [4 /*yield*/, unsubscribeFromBrandSubscriptionService(actionMessage.smtpIdentifier, actionMessage.unsubscribeSilentUris)];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    loadBrandsSubscriptions();
                }
                else {
                    // ToDo: add error message when unsubscribe fails.
                }
                return [3 /*break*/, 3];
            case 2:
                window.open(actionMessage.unsubscribeHttpUri, '_blank');
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=unsubscribeFromBrandSubscription.js.map